var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
export var Accordion = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'single' : _b, _c = _a.defaultValue, defaultValue = _c === void 0 ? type === 'single' ? 0 : [] : _c, children = _a.children, _d = _a.className, className = _d === void 0 ? '' : _d, onAccordionToggle = _a.onAccordionToggle;
    var _e = useState(function () {
        if (type === 'single') {
            return typeof defaultValue === 'number' ? [defaultValue] : [];
        }
        return Array.isArray(defaultValue) ? defaultValue : [];
    }), openItems = _e[0], setOpenItems = _e[1];
    var handleItemToggle = function (itemValue) {
        if (type === 'single') {
            setOpenItems(openItems.includes(itemValue) ? [] : [itemValue]);
            onAccordionToggle === null || onAccordionToggle === void 0 ? void 0 : onAccordionToggle(itemValue, !openItems.includes(itemValue));
        }
        else {
            setOpenItems(openItems.includes(itemValue)
                ? openItems.filter(function (item) { return item !== itemValue; })
                : __spreadArray(__spreadArray([], openItems, true), [itemValue], false));
        }
    };
    var renderChildren = function () {
        return React.Children.map(children, function (child, itemValue) {
            if (!React.isValidElement(child))
                return null;
            return React.cloneElement(child, __assign(__assign({}, child.props), { isOpen: openItems.includes(itemValue), onToggle: function () { return handleItemToggle(itemValue); } }));
        });
    };
    return _jsx("div", { className: "flex flex-col gap-2 ".concat(className), children: renderChildren() });
};
